import Vue from 'vue'
import router from '@/router'
import api from '@/api/index'
import config from '@/config/index'
import {GETORGDEPTS_SUCCESS, DEPT_UPDATE, GETORGDEPTSEMPT_SUCCESS} from "../types";

const state = {
  menus: [], // 组织架构
  dept: {}, // 当前部门
  list: [] // 当前列表(部门下面的人员)
}

const actions = {
  addDept (store, dept) {
    api.post(config.bylApiPath, '/group/add', dept, function (r) { // 提交正常
      store.dispatch('getDepts') // 重新获取
    })
  },
  delDept (store, deptId) { // 删除部门
    api.get(config.bylApiPath, '/group/delete/' + deptId, null, function (r) { // 提交正常
      store.dispatch('getDepts') // 重新获取
    })
  },
  getDepts (store) { // 获取所有小组
    api.post(config.bylApiPath, '/group/groups', null, function (r) { // 获取正常
      function iteration (data) {
        for (var j = 0; j < data.length; j++) {
          data[j].level = '1'
          data[j].opened = false
          if (data[j].children != undefined && data[j].children.length > 0) {
            iteration(data[j].children)
          }
        }
      }
      if (r.data) {
        iteration(r.data) // 递归添加属性'opened'
        store.commit(GETORGDEPTS_SUCCESS, r.data) // 更新state
        store.commit(DEPT_UPDATE, r.data[0]) // 默认取第一个部门/小组
        store.dispatch('getPersonByDept', r.data[0].id) // 默认取第一个部门下面的所有人员
      } else { // 空的情况
        store.commit(GETORGDEPTS_SUCCESS, []) // 更新state
        store.commit(DEPT_UPDATE, {}) // 默认取第一个部门
      }
    })
  },
  setDept (store, dept) {
    store.commit(DEPT_UPDATE, dept)
    // store.dispatch('getPersonByDept', dept.id)
  },
  getPersonByDept (store, deptId) {
    api.post(config.bylApiPath, '/member/members/byGroup', {id: deptId}, function (r) {
      var d;
      if (!r.data) { d = [] } else { d = r.data }
      store.commit(GETORGDEPTSEMPT_SUCCESS, d)
    })
  },
  addPerson (store, person) {
    api.post(config.bylApiPath, '/member', person, function (r) { // 提交正常
    })
  }
}
const mutations = {
  [GETORGDEPTS_SUCCESS] (state, action) {
    state.menus = action
  },
  [DEPT_UPDATE] (state, action) {
    state.dept = action
  },
  [GETORGDEPTSEMPT_SUCCESS] (state, action) {
    state.list = action
  }
}

const getters = {
  getCurrentList: state => {
    if (state.list) {
      return state.list
    } else {
      return []
    }
  },
  getCurrentDepts: state => {
    if (state.menus) {
      return state.menus
    } else {
      return []
    }
  },
  getCurrentDept: state => {
    if (state.dept) {
      return state.dept
    } else {
      return []
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/orgroup.js